'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import * as React from 'react';

import type { WithNativeDataTestIdAttribute, WithOptionalDataTestId } from '../../types/qa';
import { cn } from '../../utils';

type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & WithOptionalDataTestId;

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(({ className, dataTestId, ...props }, ref) => {
    const { 'data-testid': nativeTestId, ...rest } = props as React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & WithNativeDataTestIdAttribute;
    const testId = dataTestId ?? nativeTestId;
    return (
        <CheckboxPrimitive.Root
            ref={ref}
            data-slot="checkbox"
            data-testid={testId}
            className={cn(
                'peer size-4 shrink-0 rounded-[4px] border bg-input-background shadow-xs outline-none transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:data-[state=checked]:bg-primary dark:aria-invalid:ring-destructive/40',
                className,
            )}
            {...rest}
        >
            <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="flex items-center justify-center text-current transition-none">
                <CheckIcon className="size-3.5" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
});
Checkbox.displayName = 'Checkbox';

export { Checkbox };
